<template></template>

<script>
import { Town } from '@/webGL/objects/Town'
import { webGL } from '@/webGL/WebGL'

export default {

  data () {
    return {
      url: this.$store.getters['data/urlTown']
    }
  },

  created () {
    this.town = new Town(this.url, this.$store.getters['data/global'].train, this.$store.getters['data/global'].drone)

    webGL.scene.add(this.town)

    this.town.promise.then(() => {
      this.$emit('loaded')
    })
  }
}
</script>